<template>
  <b-media vertical-align="center">
    <template #aside>
      <b-avatar
        size="32"
        :src="getUserAvatar(user)"
        :text="sentenceCase(avatarText(getUserFullName(user)))"
        :variant="`light-${resolveUserRoleVariant(user.user_type)}`"
        :to="{ name: 'single-user', params: { id: user._id } }"
      />
    </template>
    <b-link
      :to="{ name: 'single-user', params: { id: user._id } }"
      class="font-weight-bold d-block text-nowrap"
    >
      {{
        sentenceCase(getValueFromSource(user, "member_profile.full_name"))
      }}
    </b-link>
    <span class="text-muted">{{ user.email }}</span><br />
    <span class="text-muted">@{{ user.phone }}</span>
  </b-media>
</template>

<script>
import { BMedia, BAvatar, BLink } from "bootstrap-vue";

export default {
  name: "TableUserColumn",
  components: {
    BMedia,
    BAvatar,
    BLink
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getUserAvatar(user) {
      return this.getValueFromSource(user, 'member_profile.avatar.path', '')
    },
    getUserFullName(user) {
      return this.getValueFromSource(user, 'member_profile.full_name', '')
    },
  }
};
</script>

<style></style>
